import EntryForm from '../../components/EntryForm';
import TableEditor from '../../components/TableEditor';
import ContestLabel from '../../components/ContestLabel';
import TeamLabel from '../../components/TeamLabel';
import { Table } from '../../components';
import { createOrmActions, editorPropTypes } from '../../components/common';
import { formatDate, formatName } from '../../common';

import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import { sortBy } from 'lodash';

const EntriesEditorHeader = ({ children }) => (
  <Table.Row>
    <Table.HeaderCell>Name</Table.HeaderCell>
    <Table.HeaderCell textAlign="right" style={{ width: 'calc(10ch + 1.4em)' }}>
      Date of birth
    </Table.HeaderCell>
    <Table.HeaderCell width={2}>Team</Table.HeaderCell>
    <Table.HeaderCell width={3}>Contest</Table.HeaderCell>
    <Table.HeaderCell textAlign="right" width={1}>
      Total
    </Table.HeaderCell>
    {children}
  </Table.Row>
);

const EntriesEditorRow = ({ row, children }) => (
  <Table.Row>
    <Table.Cell>{formatName(row)}</Table.Cell>
    <Table.Cell textAlign="right">
      {formatDate(row.dateOfBirth, { width: 'fixed' })}
    </Table.Cell>
    <Table.Cell>
      {row.teams.map(team => (
        <TeamLabel key={team.id} team={team} />
      ))}
    </Table.Cell>
    <Table.Cell>
      {row.contests.map(contest => (
        <ContestLabel key={contest.id} contest={contest} />
      ))}
    </Table.Cell>
    <Table.Cell textAlign="right">
      {row.total || (row.totalMinimum ? `(${row.totalMinimum})` : undefined)}
    </Table.Cell>
    {children}
  </Table.Row>
);

const EntriesEditor = ({ id, entries, actions, meta }) => {
  const rows = sortBy(entries, 'name').map(entry => ({
    ...entry,
    key: entry.primaryKey,
    title: formatName(entry),
    description: `entry ${formatName(entry)}`,
    currentValues: entry.serialized,
  }));

  const defaultValues = {
    uuid: uuid(),
    /*
    teams: [],
    gender: '',
    givenName: '',
    familyName: '',
    dateOfBirth: '',
    total: undefined,
    contests: [],
    */
  };

  return (
    <TableEditor
      id={id}
      Form={EntryForm}
      Header={EntriesEditorHeader}
      Row={EntriesEditorRow}
      rows={rows}
      defaultValues={defaultValues}
      actions={createOrmActions(actions, rows)}
      meta={meta}
    />
  );
};

EntriesEditor.propTypes = {
  ...editorPropTypes,
  entries: PropTypes.arrayOf(PropTypes.object).isRequired, // TODO: More detail
};

export default EntriesEditor;



// WEBPACK FOOTER //
// ./src/pages/Entry/EntriesEditor.js